import React, { useState } from "react"
import { StaticImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

export function Hero({ image, children, title }) {
    const [ready, setReady] = useState(false);
    // Set 'ready' variable to true (in 200ms) to get blur effect
    setTimeout(() => setReady(true), 200);

    return (
        <div className='hero'>

            <GatsbyImage
                className="bkg"
                layout="fullWidth"
                alt={`yooo`}
                loading="eager"
                image={image}
            />
            <div className='content'>
                {/* Any content here will be overlayed over the bkg image */}
                <div className="container">
                    < Link to='/'>
                        <h1 className={`blur-in ${ready ? "show" : 'not-ready'}`}>
                            {title}
                        </h1>
                    </Link>

                    <a className='shimmy-logo' href="https://shimmy-disc.net//shimmy-2010.html" target="_blank" rel="noreferrer">
                        <StaticImage
                            src="../images/shimmy-logo.png"
                            loading="eager"
                            width={130}
                            alt="Shimmy Disc"
                        />
                    </a>
                    
                   
                    {children}
                </div>
            </div>
        </div>
    )
}

Hero.propTypes = {
    image: PropTypes.object,
}

// Hero.defaultProps = {
//     image: `home`,
// }